import { useEffect, useState } from 'react'
import { useLazyReadPropertySpyByIdQuery, useReadPropertySpyByIdQuery, useSetChangesViewedMutation } from 'services/propertySpy'
import { PropertySpyResultCard } from '../../presentationals/PropertySpyResultCard'
import { Excluded_Changeable_Fields_For_Property } from 'shared/constants'
import { DateTime } from 'luxon'

interface PropertySpyResultCardContainerProps {
    propertySpyId?: number
}

export const PropertySpyResultCardContainer = (props: PropertySpyResultCardContainerProps): JSX.Element => {
    const {
        propertySpyId
    } = props

    const [propertySpyResult, setPropertySpyResult] = useState<any>(undefined)
    const [setChangesViewedMutation] = useSetChangesViewedMutation()

    const [readPropertySpyByIdQueryParams, setReadPropertySpyByIdQueryParams] = useState<any>({
        propertySpyId: propertySpyId || -1
    })

    const [readPropertySpyByIdQueryOptions, setReadPropertySpyByIdQueryOptions] = useState<any>({
        skip: propertySpyId === undefined
    })

    const {
        data: readPropertySpyByIdQueryData,
        isLoading: readPropertySpyByIdQueryIsLoading,
        isFetching: readPropertySpyByIdQueryIsFetching,
        error: readPropertySpyByIdQueryError
    } = useReadPropertySpyByIdQuery(readPropertySpyByIdQueryParams, readPropertySpyByIdQueryOptions)

    useEffect(
        () => {
            setReadPropertySpyByIdQueryParams({
                propertySpyId: propertySpyId || -1
            })
            setReadPropertySpyByIdQueryOptions({
                skip: propertySpyId === undefined
            })
        }, [
            propertySpyId
        ]
    )

    useEffect(
        () => {
            if (readPropertySpyByIdQueryData === undefined) {
                setPropertySpyResult(undefined)
                return
            }

            setChangesViewedMutation({
                hostServiceId: propertySpyId || -1
            })

            const groupingData = new Map()

            for (let i = 0; i < readPropertySpyByIdQueryData.propertyChangeLogs.length; i++) {
                const item: any = readPropertySpyByIdQueryData.propertyChangeLogs[i]

                //if (excludedChangeableFieldsForProperty.con)
                if (Excluded_Changeable_Fields_For_Property.includes(item.propName) === true) {
                    continue
                }

                const eventDate = DateTime.fromISO(item.timestampUtc)
                const indexString: string | null = eventDate.toSQLDate()

                if (!groupingData.has(indexString)) {
                    groupingData.set(indexString, [])
                }

                const gdItem = groupingData.get(indexString)
                gdItem.push(item)
            }

            setPropertySpyResult({
                changes: Array.from(groupingData, ([name, value]) => (value)).flat(),
                name: readPropertySpyByIdQueryData.name,
                pictures: readPropertySpyByIdQueryData.strHostservice.strHostservicePictures
            })
        }, [
            readPropertySpyByIdQueryData
        ]
    )

    return (
        <>
            <PropertySpyResultCard
                propertySpyResult={propertySpyResult}
            />
        </>
     
    )
}